import { definePane } from "../../main/panes/definePane";
import { TaskContent } from "./TaskPaneContent";
import { useTaskPane } from "./TaskPane.hooks";

export interface TaskPaneProps {
    taskId: string;
}

/**
 * A task on the stage. Sibling navigation lives out here so it survives the remount that stepping to a
 * sibling triggers inside TaskContent, which is keyed on the task the way the dialog was.
 */
function TaskPane(props: TaskPaneProps) {
    const { activeTaskId, navigateToTask, taskIsGone } = useTaskPane(props);

    // Not merely cosmetic: the body subscribes to the same task and would throw on the missing one, so it
    // must not render in the commit that discovers the deletion.
    if (taskIsGone) {
        return null;
    }

    // Keyed on the task so stepping to a sibling remounts the content with fresh loading state.
    return <TaskContent key={activeTaskId} taskId={activeTaskId} openedTaskId={props.taskId} onNavigateToTask={navigateToTask} />;
}

// The task saves field by field while the pane is open, and the page behind it is covered the whole time, so
// one refresh as the pane goes is both enough and the first moment the result can be seen.
export default definePane({ slot: "stage", component: TaskPane, refetchPageWhenClosed: true });
